(function () {
  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  if (!isMobile) {
    return;
  }

  var images = [
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Frame78_png_bc04e679-7832-43d9-b9f5-36745bfa5a2c.png",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Jade1_png.png?v=1780149039",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Frame1005_png.png?v=1780149122",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Frame570_png.png?v=1780149234",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Frame103_png.png?v=1780149082",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Frame_3240.png?v=1780149000",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/image_14.png?v=1780149192",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/image_15.png?v=1780149276",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/image_16.png?v=1780149313",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/Emma_Bikini.png?v=1786192972",
    "https://cdn.shopify.com/s/files/1/0834/5632/8008/files/cdb1bf27-7845-4791-8b6d-db4a6752fbfa_1_1172e4ec-2f7a-401d-bc19-c9f192064436.png?v=1780149355"
  ];

  function initMobileMenuImages() {
    var nav = document.querySelector('ul.mobile-nav');

    if (!nav || nav.classList.contains('ab-menu-images-applied')) {
      return;
    }

    nav.classList.add('ab-menu-images-applied');

    var items = nav.querySelectorAll('li');

    for (var i = 0; i < items.length && i < images.length; i++) {
      var item = items[i];
      var link = item.querySelector('a');

      if (!link) {
        continue;
      }

      item.classList.add('ab-menu-image-item');
      link.classList.add('ab-menu-image-link');

      var img = document.createElement('img');

      img.src = images[i];
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'ab-menu-image';

      link.insertBefore(img, link.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuImages);
  } else {
    initMobileMenuImages();
  }
})();